export const isChildrenAsFunction = (children: any): children is Function => typeof children === 'function';
